export default {
  SET_ROW (state, parameter) {
    state.row = parameter
  },
  SET_BANK (state, parameter) {
    state.bank = parameter
  },
  SET_ACTIVE (state, parameter) {
    state.active = parameter
  },
  SET_SHOPROW (state, parameter) {
    state.shopRow = parameter
  },
  SET_USERINFO (state, parameter) {
    state.userInfo = parameter
  },
  SET_SYSTEMINFO (state, parameter) {
    state.systemInfo = parameter
  },
  SET_KEEPALIVELIST (state, parameter) {
    state.keepAliveList = parameter
  },
  SET_PROBLEMINFO (state, parameter) {
    state.problemInfo = parameter
  },
  SET_NOTICEINFO (state, parameter) {
    state.noticeInfo = parameter
  },
  SET_SELECTFREIGHTMODELS (state, parameter) {
    state.selectFreightModels = parameter
  },
  SET_PAYINFO (state, parameter) {
    state.payInfo = parameter
  }
}
